<!-- 座席 -->
<template>
  <div v-for="(s, i) in selectedSeats" :key="i" class="row">
    <div class="th cell"><span v-if="i == 0">座席</span></div>
    <div class="cell">{{ s.car_number }}号車 {{ s.seat.display_number }}</div>
  </div>
</template>

<script>
export default {
  name: "StoreSelectedSeats",
  props: {
    selectedSeats: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  display: table;
  font-size: 13px;
}
.row {
  display: table-row;
}

.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 14px;
  color: grey;
  padding-right: 14px;
}
.arrow {
  width: 10px;
  height: auto;
  padding: 0 6px 1px 6px;
}
</style>
